import { jsx as _jsx } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
function NoFilterResults({ text = __("No results found", "quicktasker"), }) {
    return _jsx("div", { className: "wpqt-font-semibold", children: text });
}
export { NoFilterResults };
